// mockData.js
export const mockOrganizations = [
  {
    id: '1',
    orgName: 'Mock Org 1',
    description: 'This is a test organization',
    brandColor: '#00f',
    logoImg: '',
  },
  {
    id: '2',
    orgName: 'Mock Org 2',
    description: 'Another test organization',
    brandColor: '#f00',
    logoImg: '',
  },
];

export const mockQueues = {
  1: [{ id: 'q1' }, { id: 'q2' }],
  2: [{ id: 'q3' }],
};
